module.exports = __webpack_public_path__ + "static/img/chan_1.7d5a5e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chan_1.png
// module id = 6xTX
// module chunks = 0